import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import FormButtonGroup from 'App/components/styles/FormButtonGroup';
import { TextInput } from 'Shared/form/TextField';
import useSaveWorkQueueFilterMutation from '../hooks/useSaveWorkQueueFilterMutation';
import { transformReactFilterToSave } from '../workQueue.utils';
import { useFormikContext } from 'formik';
import { useUserPreferences } from 'App/contexts/UserPreferencesContext';
import { FILTER_TYPE } from '../workQueue.constant';
import * as R from 'ramda';

const propTypes = {
    onHide: PropTypes.func.isRequired,
};

function SaveFilterModal({ onHide }) {
    const saveFilterMutation = useSaveWorkQueueFilterMutation();
    const [savedFilterName, setSavedFilterName] = useState('');
    const [isSaving, setIsSaving] = useState(false);
    const { setPreference } = useUserPreferences();

    const {
        values: {
            filterParams,
            filterType,
            allBranchesList,
            allCategoriesList,
            allActivityTypesList,
            allPatientLabelsList,
            allCustomOptionsList,
        },
        setFieldValue,
    } = useFormikContext();

    const saveFilter = () => {
        setIsSaving(true);
        saveFilterMutation
            .mutateAsync({
                filter: transformReactFilterToSave(
                    filterParams,
                    allBranchesList,
                    allCategoriesList,
                    allActivityTypesList,
                    allPatientLabelsList,
                    allCustomOptionsList
                ),
                name: savedFilterName,
                filterType,
            })
            .then((res) => {
                setSavedFilterName('');
                setFieldValue('activeSavedFilter', R.values(res)[R.values(res).length - 1]?.id);
                if (filterType === FILTER_TYPE.WORK_QUEUE) {
                    setPreference('workQueue_activeSavedFilter', R.values(res)[R.values(res).length - 1]?.id);
                } else {
                    setPreference('assignmentManager_activeSavedFilter', R.values(res)[R.values(res).length - 1]?.id);
                }
                onHide(true);
            })
            .catch(() => setIsSaving(false));
    };

    return (
        <Modal show onHide={onHide} backdrop="static">
            <Modal.Header>
                <Modal.Title role="heading">Save Filter</Modal.Title>
            </Modal.Header>
            <form>
                <Modal.Body>
                    <Row>
                        <Col md={12}>
                            <TextInput
                                name="savedFilterName"
                                label="Name"
                                placeholder="Name"
                                value={savedFilterName}
                                onChange={(e) => setSavedFilterName(e.target.value)}
                                maxLength={20}
                            />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <FormButtonGroup>
                        <Button variant="outline-secondary" disabled={isSaving} onClick={onHide}>
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            disabled={isSaving || !savedFilterName || R.pipe(R.trim, R.isEmpty)(savedFilterName)}
                            onClick={saveFilter}
                        >
                            Save
                        </Button>
                    </FormButtonGroup>
                </Modal.Footer>
            </form>
        </Modal>
    );
}

SaveFilterModal.propTypes = propTypes;

export default SaveFilterModal;
